<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
            enabled: true,
            skipDiacritics: true,
            placeholder: 'Cerca un cliente'
        }"
        :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 50
      }"
      theme="polar-bear">
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'isdone'">
              <span v-if="props.row.status == 'request'" class="px-6 bg-yellow-200 rounded-lg">request</span>
              <span v-if="props.row.status == 'done'" class="px-6 bg-green-200 text-green-600 rounded-lg">done</span>
            </span>
            <span v-if="props.column.field == 'action'">
            <span style="font-weight: bold;">
                <a class="mx-2 bg-green-600 rounded-md p-2 text-white hover:bg-green-900 action-tooltip" :href="`/students/show/${props.row.theasking.id}`">
                    <svg viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                    <span class="tiptext">vedi scheda</span>
                </a>                
            </span> 
            </span>
            <span v-else>
            {{props.formattedRow[props.column.field]}}
            </span>
        </template>
    </vue-good-table>
  </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';
import { Form } from 'vform';

export default {
    props: ['rows'],
    components : {VueGoodTable},
    name: 'table-students',
  data(){
    return {
       form: new Form({
                id:''
        }),
      columns: [
        {
          label: 'Cliente',
          field: 'theasking.name',
          sortable: true
        },
        {
          label: 'Email',
          field: 'email',
          sortable: true
        },
        {
          label: 'Stato',
          field: 'isdone',
          sortable: true
        },
        {
          label: 'Azioni',
          field: 'action',
          sortable: false
        },
      ],


    };
  },
};
</script>


<style>

.action-tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.action-tooltip  .tiptext {
  visibility: hidden;
  width: 120px;
  background-color: rgba( 0,0,0, 0.7 );
  color: #fff;
  font-size: 11px;
  text-align: center;
  padding: 4px 0;
  border-radius: 6px;
  position: absolute;
  width: 80px;
  bottom: 105%;
  left: 50%;
  margin-left: -40px;
  z-index: 1;
  }

.action-tooltip:hover .tiptext {
  visibility: visible;
}

</style>